<template>
  <div v-if="permissoes.gerencial_painel">
    <!-- Breadcrumb e Cabeçalho -->
    <el-row class="el-row-topo">
      <el-col :span="24">
        <el-breadcrumb separator-class="el-icon-arrow-right">
          <el-breadcrumb-item :to="{ path: '/' }">Home</el-breadcrumb-item>
          <el-breadcrumb-item>Orçamentos de Negócio</el-breadcrumb-item>
          <el-breadcrumb-item>Revisão</el-breadcrumb-item>
          <el-breadcrumb-item>Itens</el-breadcrumb-item>
        </el-breadcrumb>
      </el-col>
    </el-row>
    <!-- Título -->
    <el-row type="flex" justify="center">
      <el-col :span="24">
        <h1>Gestão de Itens da Revisão do Negócio</h1>
      </el-col>
    </el-row>
    <el-form 
      label-width="80px" 
      size="small">
      <el-row :gutter="20">
          <el-col :span="6">
            <el-form-item label="Filtrar por">
              <el-select
                v-model="filtro.tipo"
                placeholder="Selecione o tipo de filtro"
                clearable
                @change="aoMudarTipoFiltro"
                style="width: 100%">
                <el-option label="Fabricante" value="fabricante"></el-option>
                <el-option label="Grupo" value="grupo"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="13">
            <el-form-item :label="labelSegundoSelect">
                <el-select
                  v-model="filtro.valor"
                  :placeholder="placeholderSegundoSelect"
                  filterable
                  clearable
                  :loading="carregandoOpcoes"
                  style="width: 100%">
                  <el-option
                    v-for="item in opcoesFiltro"
                    :key="item.codigo"
                    :label="item.nome"
                    :value="item.codigo">
                  </el-option>
                </el-select>
              </el-form-item>
          </el-col>
          <el-col :span="5" style="display: flex; align-items: flex-end;">
            <el-button @click="limparFiltro" icon="el-icon-refresh-right">
              Limpar
            </el-button>
          </el-col>
        </el-row>
    </el-form>
    <!-- Tabela -->
    <el-row type="flex" justify="start" aling="left">
      <el-col :span="24">
        <el-table
          ref="itensAgrupadosTable"
          :key="tableKey"
          :data="itensFiltrados"
          style="width: 100%"
          v-loading="loading"
          element-loading-text="Carregando..."
          @selection-change="handleSelectionChange"
        >
          <el-table-column type="selection" width="55" align="center"></el-table-column>
          <el-table-column prop="codigo" label="Código" width="95" sortable></el-table-column>
          <el-table-column prop="descricao" label="Descrição" min-width="230" sortable></el-table-column>
          <el-table-column prop="fabricante" label="Fabricante" min-width="230" sortable></el-table-column>
          <el-table-column prop="grupo" label="Grupo" min-width="230" sortable></el-table-column>
          <el-table-column prop="part_number" label="Part Number" width="110"></el-table-column>
          <el-table-column prop="registros" label="Registros" width="85" align="right"></el-table-column>
          <el-table-column prop="quantidade" label="Quantidade" width="100" align="right"></el-table-column>
          <el-table-column prop="unitario_1" label="Unitário 1" width="95" align="right"></el-table-column>
          <el-table-column prop="fator_mp" label="Fator" width="80" align="right" sortable></el-table-column>
          <el-table-column prop="unitario_2" label="Unitário 2" width="95" align="right"></el-table-column>
          <el-table-column prop="total" label="Total" width="110" align="right" sortable :sort-method="sortPreco"></el-table-column>
          <el-table-column label="Ação" width="130">
            <template slot-scope="scope">
              <el-tooltip v-if="permissoes.gerencial_painel" class="item" effect="light" content="Editar Fator do Item para a Revisão do Negócio" placement="top">
                <el-button size="mini" type="primary" icon="el-icon-edit" @click="editarFator(scope.row)">Editar Fator</el-button>
              </el-tooltip>
            </template>
          </el-table-column>
        </el-table>
      </el-col>
    </el-row>
    <!-- Formulário -->
    <el-dialog
      title="Editar Fator do Item"
      :visible.sync="dialogFormVisible"
      :show-close="false"
      width="600px"
    >
      <el-form
        :model="form"
        :rules="rules"
        ref="formItem"
        label-position="right"
        label-width="130px"
        size="small"
      >    

        <el-row :gutter="20">
          <el-col :span="11">
            <el-form-item label="Código">
              <el-input class="input-disabled" v-model="form.codigo" disabled></el-input>
            </el-form-item>
          </el-col>
        </el-row>

        <el-form-item label="Descrição">
          <el-input class="input-disabled" v-model="form.descricao" disabled type="textarea" :rows="3"></el-input>
        </el-form-item>

        <el-row :gutter="20">
          <el-col :span="15">
            <el-form-item label="Part Number">
              <el-input class="input-disabled" v-model="form.part_number" disabled></el-input>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row :gutter="20">
          <el-col :span="11">
            <el-form-item label="Quantidade">
              <el-input class="input-disabled direita" :value="formatarValor(form.quantidade, 4)" disabled></el-input>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row :gutter="20">
          <el-col :span="11">
            <el-form-item label="Unitário 1">
              <el-input class="input-disabled direita" :value="formatarValor(form.unitario_1, 4)" disabled></el-input>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row :gutter="20">
          <el-col :span="11">
            <el-form-item label="Fator MP" prop="fator">
                <el-input-number
                  ref="fatorInput"
                  class="direita"
                  v-model="form.fator_mp"
                  :precision="4"
                  :step="0.0001"
                  :min="0"
                  controls-position="right"
                  @input.native="atualizarEmTempoReal"
                  style="width: 100%">
                </el-input-number>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row :gutter="20">
          <el-col :span="11">
            <el-form-item label="Unitário 2">
              <el-input class="input-disabled direita" :value="formatarValor(form.unitario_2_virtual, 2)" disabled></el-input>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row :gutter="20">
          <el-col :span="11">
            <el-form-item label="Total">
              <el-input class="input-disabled direita" :value="formatarValor(form.total_virtual, 2)" disabled></el-input>
            </el-form-item>
          </el-col>
        </el-row>

      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="handleClose()">Cancelar</el-button>
        <el-button type="primary" @click="gravarFator()">Salvar</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>

import axios from "axios";
import FuncoesUteis from "../../plugins/FuncoesUteis";

const url = "/api";

export default {

  data() {
    return {
      loading: true,
      dialogFormVisible: false,
      permissoes: {},
      fabricante: {},
      representantes: [],
      // negocio_itens: [],
      itensOriginais: [],
      carregandoOpcoes: false,
      filtro: {
        tipo: '',    // 'fabricante' ou 'grupo'
        valor: ''    // código selecionado
      },
      opcoesFiltro: [],       // opções carregadas do servidor
      form: {},
      rules: {
        fator_mp: [
          { required: true, message: "Por Favor, informe o Fator", trigger: "blur" },
        ],
      },
      itensSelecionados: [], // Para armazenar os itens selecionados na tabela
      tableKey: 0, // Para forçar a re-renderização da tabela quando necessário
    };
  },

  computed: {
    isLoggedIn: function () {
      return this.$store.getters.isLoggedIn;
    },

    itensFiltrados() {
      if (!this.filtro.valor) return this.itensOriginais;
      return this.itensOriginais.filter(item => {
        if (this.filtro.tipo === 'fabricante') {
          return item.fabricante_cod == this.filtro.valor;
        }
        if (this.filtro.tipo === 'grupo') {
          return item.grupo_cod == this.filtro.valor;
        }
        return true;
      });
    },

    dadosTabela() {
      if (!this.divisao.itens) return [];
      if (!this.search) return this.divisao.itens;
      return this.filtrarArvore(this.divisao.itens, this.search.toLowerCase());
    },

    dadosFiltrados() {
      if (!this.search) {
        return this.divisao.itens
      }
      return this.filtrarArvore(this.divisao.itens, this.search.toLowerCase())
    },

    labelSegundoSelect() {
      if (!this.filtro.tipo) return 'Selecione';
      return this.filtro.tipo === 'fabricante' ? 'Fabricante' : 'Grupo';
    },

    placeholderSegundoSelect() {
      if (!this.filtro.tipo) return 'Primeiro selecione o tipo de filtro';
      return this.filtro.tipo === 'fabricante' 
        ? 'Selecione um fabricante' 
        : 'Selecione um grupo';
    },

    // Se você já tem dadosTabela, use isso para evitar duplicar
    dadosTabelaFiltrados() {
      // Se não houver filtro ativo, retorna todos
      
      if (!this.filtro.tipo || !this.filtro.valor) {
        return this.dadosTabelaOriginal;
      }

      // Filtra recursivamente na árvore
      const filtrarArvore = (itens) => {
        return itens
          .map(item => {
            let novoItem = { ...item };
            if (novoItem.filhos && novoItem.filhos.length > 0) {
              novoItem.filhos = filtrarArvore(novoItem.filhos);
            }

            // Verifica se o item tem o código do fabricante/grupo
            const campo = this.filtro.tipo === 'fabricante' ? 'cod_fabricante' : 'cod_grupo';
            if (novoItem[campo] === this.filtro.valor) {
              return novoItem;
            }

            // Mantém o pai se tiver filhos que atendem ao filtro
            if (novoItem.filhos && novoItem.filhos.length > 0) {
              return novoItem;
            }

            return null;
          })
          .filter(item => item !== null);
      };

      return filtrarArvore(this.dadosTabelaOriginal);
    },

  },

  mounted() {
    this.permissoes = FuncoesUteis.isPermissao();
    if (!this.permissoes.gerencial_painel) {
      this.$message.error("Você não tem permissão para acessar esta página.");
      this.$router.push("/");
      return;
    }
    // this.getDados();
    this.buscarItensNegocioRevisaoAgrupado();
  },

  watch: {
    search() {
      this.tableKey++  // Força remontar a tabela com os dados filtrados
    },
    'form.fator_mp': {
      handler() {
        this.atualizarEmTempoReal();
      },
    }
  },

  methods: {

    // async getDados() {
    //   await this.buscarItensNegocioRevisaoAgrupado();
    // },

    async buscarItensNegocioRevisaoAgrupado() {
      try {
        this.loading = true;
        const id = this.$route.params.id;
        // console.log('this.$route.params.id', this.$route.params.id);
        const response = await axios.get(url + '/orcamento/negocio/revisao/itens/'+id, {
          headers: { Authorization: "Bearer " + this.$store.state.token },
        });
        if (response.data.status === "Token is Expired") {
          await this.$store.dispatch("logout");
          this.$router.push("/login");
        } else {
          this.itensOriginais = response.data;
          // console.log('Itens Originais: ', this.itensOriginais);
        }
      } catch (error) {
        this.$message.error('Erro ao buscar Itens da Revisão: ' + error.message);
      } finally {
        this.loading = false;
      }
    },

    editarFator(row = null) {
      if (row) {
        this.form = { ...row };
        this.form.unitario_2_virtual = 0;
        this.form.total_virtual = 0;
      } else {
          this.form = { 
            id: null,
            fabricante_id: this.fabricante.fabricante_id,
         };
      }
      this.dialogFormVisible = true;
    },

    atualizarEmTempoReal() {
      if (this.$refs.fatorInput) {
        const inputEl = this.$refs.fatorInput.$el.querySelector('input');
        if (inputEl) {
          let valor = parseFloat(inputEl.value.replace(',', '.')) || 0;
          this.form.unitario_2_virtual = this.form.unitario_1*valor;
          this.form.total_virtual = this.form.unitario_2_virtual*this.form.quantidade;
        }
      }
    },

    handleClose() {
      this.$confirm("Deseja fechar sem salvar?", "Aviso", {
        confirmButtonText: "Sim",
        cancelButtonText: "Não",
        type: "warning",
      })
        .then(() => {
          this.dialogFormVisible = false;
        })
        .catch(() => {});
    },

    // Captura as linhas selecionadas na tabela
    handleSelectionChange(selection) {
      this.itensSelecionados = selection;
    },

    async gravarFator() {
      this.$refs.formItem.validate(async (valid) => {
        if (!valid) {
          this.$message.info("Preencha os dados corretamente!");
          return;
        }

        try {

          this.loading = true;

          const payload = {
            negocio_revisao_id: this.form.negocio_revisao_id,
            codigo: this.form.codigo,
            fator_mp: this.form.fator_mp,
          };

          const response = await axios.post(url + '/divisao-negocio-atividade/alterar-fator-codigo', payload, {
            headers: {
              Authorization: "Bearer " + this.$store.state.token,
            }
          });

          // Verificação de token nas mensagens de status da API
          const statusErroToken = ["Token is Expired", "Token is Invalid", "Authorization Token not found"];
          if (statusErroToken.includes(response.data.status)) {
            await this.$store.dispatch("logout");
            this.$router.push("/login");
            return;
          }

          this.$notify({
            title: "Sucesso",
            message: "Dados dos Detalhes do Itens da Atividade da Divisão do Negócio recuperados com sucesso!",
            type: "success",
          });

        this.dialogFormVisible = false;
        await this.buscarItensNegocioRevisaoAgrupado();
          
        } catch (error) {
          console.error('Erro ao modificar o fator:', error);

          if (error.response && error.response.status === 401) {
            this.$message.error("Sessão expirada. Faça login novamente.");
            await this.$store.dispatch("logout");
            this.$router.push("/login");
          } else {
            this.$message.error('Falha ao processar a requisição. Tente novamente.');
          }

        } finally {
          this.loading = false;
        }

      });
    },

    formatarValor(valor, casas = 2) {
      if (!valor && valor !== 0) {
        return '-';
      }
      // Converte para número para garantir que a formatação funcione
      const valorNumerico = Number(valor);
      // Verifica se é um número válido
      if (isNaN(valorNumerico)) {
        return valor;
      }
      // Usa Intl.NumberFormat para o padrão brasileiro (ponto no milhar, vírgula para decimal)
      return new Intl.NumberFormat('pt-BR', {
        minimumFractionDigits: casas,
        maximumFractionDigits: casas
      }).format(valorNumerico);
    },
    sortPreco(a, b) {
      // Remove o "R$", pontos de milhar e troca vírgula por ponto
      const limpar = (valor) => {
        if (!valor) return 0;
        return parseFloat(valor.replace(/[^\d,-]/g, '').replace(',', '.'));
      };
      return limpar(a.total) - limpar(b.total);
    },

    // Quando muda o tipo de filtro (Fabricante ou Grupo)
    aoMudarTipoFiltro() {
      this.filtro.valor = '';
      this.opcoesFiltro = [];
      
      if (!this.filtro.tipo) {
        return;
      }

      this.carregarOpcoesFiltro();
    },

    // Limpa todos os filtros
    limparFiltro() {
      this.filtro.tipo = '';
      this.filtro.valor = '';
      this.opcoesFiltro = [];
    },

    // Busca as opções no backend Laravel
    async carregarOpcoesFiltro() {
      this.carregandoOpcoes = true;
      this.opcoesFiltro = [];

      // console.log("Carregar opções de filtro para tipo:", this.filtro.tipo);

      try {

        const id = this.$route.params.id;

        if (!id || isNaN(id)) {
          this.$notify.warning({ title: 'Atenção', message: 'Código da Divisao do Negócio vazio.' });
          return;
        }

        // console.log("id: " + id);
        
        const endpoint = this.filtro.tipo === 'fabricante' 
          ? `/orcamento/divisao/negocio/lista-fabricantes-2/${id}` 
          : `/orcamento/divisao/negocio/lista-grupos-2/${id}`;

        // console.log("URL completa:", url + endpoint);

        const response = await axios.get(url + endpoint, {
          headers: {
            Authorization: "Bearer " + this.$store.state.token,
          }
        });

        // console.log("DADOS RECEBIDOS:", response.data);

        this.opcoesFiltro = response.data.map(item => ({
          codigo: item.CODIGO,
          nome: this.filtro.tipo === 'fabricante' ? item.FABRICANTE : item.GRUPO
        }));
      } catch (error) {
        this.$message.error('Erro ao carregar opções de filtro');
        console.error(error);
      } finally {
        this.carregandoOpcoes = false;
      }
    },


  },


};

</script>

<style scoped>
  .select-representante {
    width: 60%;
    margin-right: 10px;
  }
  .input-disabled .el-input__inner,
  .input-disabled .el-textarea__inner {
    background-color: #fafafa !important;
    color: #585858 !important;
    cursor: text !important;
  }
  .direita .el-input__inner{
    text-align: right !important;
  }
</style>
